const PostAndComment = () => {
   return (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M9.545 13.636h8.182M9.545 16.91h8.182">
         </path>
         <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M9.545 7.09h8.182v3.274H9.545V7.09z"></path>
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M4.636 21A1.641 1.641 0 013 19.364v-6.546h.818">
         </path>
         <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M6.273 3v16.364A1.641 1.641 0 014.637 21h14.727A1.641 1.641 0 0021 19.364V3H6.273z">
         </path>
      </svg>
   )
}

export default PostAndComment